import { FC, PropsWithChildren } from 'react'
import Image from 'next/image'
import { Heading, Paragraph } from '@alto-avios/alto-ui'
import { PlatformThemeId } from '@reward-platform/platform-config'

import { ThemeProvider } from '~/context/theme'
import { getLogoUrlForTheme } from '~/utils/assets'

import styles from './MaintenanceModePage.module.scss'

type PageProps = PropsWithChildren<{ themeId?: PlatformThemeId }>

export const MaintenanceModePage: FC<PageProps> = ({ children, themeId = 'avios' }) => {
  return (
    <ThemeProvider themeId={themeId}>
      <div className={styles.container}>
        <div className={styles.imageContainer}>
          <Image
            src={getLogoUrlForTheme(themeId)}
            alt={`brand logo for ${themeId}`}
            width={240}
            height={240}
          />
        </div>
        <div>
          <Heading size="md">Site is down for maintenance</Heading>
          <Paragraph size="lg">
            We are working hard to be up and running soon, please try again later.
          </Paragraph>
        </div>
      </div>
    </ThemeProvider>
  )
}
